<p-dialog [header]="'HEADBAND.MODAL.TITLE' | translate" [(visible)]="showDialog" [modal]="true" [style]="{ width: '40rem' }" (onHide)="onCancel()">
    <img class="img-depth" src="assets/images/depth-schema.png" alt="Description de l'image" style="width: 100%; max-width: 300px;">
    <div>{{ 'HEADBAND.MODAL.CREDIT' | translate }}</div>
  </p-dialog>
  